<script lang="ts">
	import { onMount } from 'svelte';
	import { format } from 'svelte-i18n';
	import { getMappedRoomList, getGroupRoomList } from '../../../Lists/list-helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	import SelectList from 'src/components/SelectList/SelectList.svelte';
	import { Container } from '@Shelly/shelly-design-system';

	export let editGroup;
	export let selectedRef: HTMLElement = null;

	const globalGroup = {
		name: 'Global',
		icon: 'fas fa-globe',
		filepath: '',
		id: -1,
	};

	let roomListDB = [];
	let allRoomsRefs: { [key: string | number]: HTMLElement } = {};

	$: roomListMapped = getMappedRoomList(roomListDB, editGroup.room_id);

	$: selectedRef = allRoomsRefs[editGroup.room_id];

	const onSelectRoom = (room) => {
		editGroup.room_id = room.id;
	};

	onMount(() => {
		roomListDB = [globalGroup, ...getGroupRoomList()];
	});
</script>

<Container noScroll padding="0">
	<SelectList
		title={capFirstChar(
			$format('select_type', {
				values: {
					type: $format('process_room', { default: 'room' }),
				},
				default: 'Select room',
			}),
		)}
		list={roomListMapped}
		variant="radio"
		bind:allCardsRefs={allRoomsRefs}
		on:click={(e) => onSelectRoom(e.detail)}
	/>
</Container>
